import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: 'pkce',
    debug: process.env.NODE_ENV === 'development',
    url: window.location.hostname === 'localhost' || window.location.hostname === 'sangre-fuerte.millev.com'
      ? `${window.location.origin}/auth/callback`
      : 'com.sangrefuerte.app://auth/callback'
  }
}); 